import { css } from 'styled-components'
import { ThemedComponentProps } from '../theme.types'
import { rem } from './units'
import { borderColor } from './color'

export const borderRadius = (props: ThemedComponentProps) => rem(props.theme.borderRadius)

export const roundedCorners = css`
  border-radius: ${borderRadius};
`

export const border = (props: ThemedComponentProps) => `1px solid ${borderColor(props)}`
